import React from 'react';
import PropTypes from 'prop-types';
import CategoryRow from './CategoryRow';

const Categories = props => {
  const {
    categories = [],
    fptiClick,
    fptiImpression,
    toolTileProps,
    viewAllText
  } = props;

  return (
    <div id="appcenter-categories">
      {categories.map(({ content = {}, featured = [] }, index) => (
        <CategoryRow
          key={`appcenter-categories-${index}`}
          content={content}
          featured={featured}
          viewAllText={viewAllText}
          fptiClick={fptiClick}
          fptiImpression={fptiImpression}
          toolTileProps={toolTileProps}
        />
      ))}
    </div>
  );
};

Categories.propTypes = {
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  categories: PropTypes.array,
  toolTileProps: PropTypes.object,
  viewAllText: PropTypes.string
};

export default Categories;
